define('core/mixins/withRichMedia',[
    'underscore',
    'jquery',

    'core/collections/MediaCollection',
    'core/media',
], function (
    _,
    $,

    MediaCollection,
    coreMedia
) {
    'use strict';

    function getLinks($fragment) {
        var links = {};

        if (!$fragment.length)
            return links;

        $fragment.find('a').each(function (__, link) {
            var url = link.href;
            if (!links[url])
                links[url] = $(link);
        });

        return links;
    }

    var RichMediaRenderableView = {
        renderRichMedia: function (media, mediaNode, options) {
            options = options || {};
            media = media instanceof MediaCollection ?
                media :
                new MediaCollection(media);

            return media.chain()
                .map(function (item) {
                    return coreMedia.instantiateRichMediaView(item);
                })
                // Filter out unusable media
                // TODO: There should never be unusable media
                .without(null)
                .map(function (view) {
                    var url = view.media.get('urlRedirect');

                    if (options.normalize)
                        url = options.normalize.call(this, url);

                    var links = getLinks(this.$('[data-role=message]'));
                    var $link = links[url];

                    if (options.beforeRender)
                        options.beforeRender.call(this, view);

                    // Render before putting on the DOM to
                    // minimize DOM updates
                    view.render();

                    if ($link) {
                        if (options.convertLinkToButton) {
                            // Place the media after the link
                            $link.after(view.$el);

                            // Convert link into button which toggles the media when
                            // media is collapsible.
                            view.convertToButton($link);
                        } else {
                            $link.replaceWith(view.$el);
                        }
                    } else {
                        mediaNode = mediaNode || this.$('[data-role=post-media-list]');
                        mediaNode.append($('<li>').append(view.$el));
                    }

                    return view;
                }, this)
                .value();
        },
    };

    function withRichMediaView() {
        _.extend(this, RichMediaRenderableView);
    }

    return withRichMediaView;
});

